module.exports = __webpack_public_path__ + "img/SKLB-Colabordores.b542caea.png";